const indexPages = ['introduction', 'home-pro', 'README'];
exports.indexPages = indexPages;

exports.pageNametoLabel = (name) => {
  if (name === 'dns') {
    return "DNS"
  }
  if (name === 'api-reference') {
    return "API Reference"
  }
  if (indexPages.includes(name)) {
    return "Overview"
  }
  // Replace dashes/underscores with spaces, then capitalize each word
  return name
    .replace(/[-_]/g, " ")
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ")
}
